import React, { useState } from "react";
import { Container, Tabs, Tab, Box, Typography } from "@mui/material";
import AdminFeaturedPosts from "./AdminFeaturedPosts";
import WebsiteFeatures from "./WebsiteFeatures";
import WebsiteSponsors from "./WebsiteSponsors";
import ManageEvents from "./ManageEvents";

function WebsiteManagement() {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Container>
      <Box my={4}>
        <Typography variant="h4" gutterBottom>
          Website Management
        </Typography>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Featured Posts" />
          <Tab label="Website Features" />
            <Tab label="Sponsors" />
            <Tab label="Manage Events" />
          {/* Add more tabs here if needed */}
        </Tabs>
        <Box mt={3}>
          {selectedTab === 0 && <AdminFeaturedPosts />}
          {selectedTab === 1 && <WebsiteFeatures />}
          {selectedTab === 2 && <WebsiteSponsors />}
          {selectedTab === 3 && <ManageEvents />}
        </Box>
      </Box>
    </Container>
  );
}

export default WebsiteManagement;
